// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2qCLg","range":"MonthRangeSwitch_range__2SqL6","disabled":"MonthRangeSwitch_disabled__3ME7n"};